import * as React from "react"
import { Link } from "gatsby"
import { useSiteContext } from "../hooks/use-site-context"

const Footer = () => {
  return (
    <footer>
      <div className={`w-full bg-brand-dark border-b border-gray-600`}></div>
      <>
        {/* <div className="max-w-4xl px-6 mx-auto mt-4 text-xs text-center text-gray-500">
            For Product Support, please contact the seller{" "}
            <a
              className="hover:text-brand-pink"
              href="mailto:james@thetruthinyourstars.com"
            >
              HERE.
            </a>
            <br />
            For Order Support, please contact ClickBank{" "}
            <a
              className="hover:text-brand-pink"
              target="_blank"
              href="https://www.clkbank.com/#!/"
            >
              HERE.
            </a>
          </div> */}
        <div className="max-w-4xl px-6 mx-auto mt-4 text-xs text-center text-gray-500">
          ClickBank is the retailer of products on this site. CLICKBANK® is a
          registered trademark of Click Sales, Inc., a Delaware corporation
          located at 1444 S. Entertainment Ave., Suite 410 Boise, ID 83709, USA
          and used by permission. ClickBank's role as retailer does not
          constitute an endorsement, approval or review of these products or any
          claim, statement or opinion used in promotion of these products. The
          contents of this site, and all communications sent on behalf of this
          site, are for entertainment purposes only. James Seabrook is a pen
          name. For product support, please contact the seller{" "}
          <a
            className="hover:text-brand-pink"
            href="mailto:james@thetruthinyourstars.com"
          >
            here.
          </a>{" "}
          For order support, please contact ClickBank{" "}
          <a
            className="hover:text-brand-pink"
            target="_blank"
            href="https://www.clkbank.com/#!/"
          >
            here.
          </a>
        </div>
        <div
          className={`w-full py-10 h-16 bg-brand-dark flex items-center text-gray-500 justify-center space-x-6 md:space-x-12`}
        >
          {/* <p className="text-sm sm:text-base whitespace-nowrap">
        <span className="text-xs sm:text-sm">&copy;</span>{" "}
        {new Date().getFullYear()}
      </p> */}
          <Link
            className="text-sm sm:text-base hover:text-brand-pink whitespace-nowrap"
            to="/privacy-policy"
          >
            Privacy Policy
          </Link>
          <Link
            className="text-sm sm:text-base hover:text-brand-pink whitespace-nowrap"
            to="/terms-and-conditions"
          >
            Terms & Conditions
          </Link>
          <Link
            className="text-sm sm:text-base hover:text-brand-pink whitespace-nowrap"
            to="/affiliates"
          >
            Affiliates
          </Link>
        </div>
      </>
    </footer>
  )
}

export default Footer
